import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from '@/store'
import i18n, { setup } from './i18n/i18n'
import navgate from './views/main/navigate/navgate.vue'
import footerBuild from './views/main/footer/footerBuild.vue'
import multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import axios from 'axios'  //导入axios
import Paginate from 'vuejs-paginate'
import pageUtil from './util/pageUtil'
import HttpUtils from './util/HttpUtils'
import navgateOther from './views/main/navigate/navgateOther.vue'
import './assets/css/ks_website.less';
import './assets/css/ks_website_m.less';
import './assets/fonts/iconfont.css';

Vue.prototype.$httpUtil = new HttpUtils()
Vue.prototype.$PageUtil = new pageUtil()
Vue.prototype.$http=axios
Vue.config.productionTip = false
Vue.prototype.$store=store

Vue.component('multiselect',multiselect)
Vue.component('paginate',Paginate)
Vue.component('navgate',navgate)
Vue.component('navgateOther',navgateOther)
Vue.component('footerBuild',footerBuild)

// 初始化语言设置
setup()

new Vue({
  router,
  i18n,
  render: h => h(App),
}).$mount('#app')
